<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Pencarian
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Nomor Surat</label>
          <b-form-input 
            v-model="filter.nomor_surat"
            placeholder="nomor_surat"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Jenis Sidang</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            v-model="filter.jenis_sidang_id"
            :options="jenisSidangOption.options"
            class="w-100"
            :reduce="val => val.value"
            placeholder="Pilih Jenis Sidang"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
          <b-button variant="primary" @click="cari()">Cari</b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  getJenisSidang,
  getStatusJadwalSidang,
} from '@/connection-api/master'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormInput,
    BButton,
  },
  data() {
    return {
      filter: {},
      count: 0,
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Sidang --' },
        ],
      },
      statusJadwalOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Jadwal Sidang --' },
        ],
      },
    }
  },
  props: {
    triggerFilter: {
      default: null,
    },
    dataFilter: {
      default: null,
    },
  },
  beforeCreate() {
      getJenisSidang()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.jenisSidangOption.options.push({
            label: element.nama,
            value: element.uuid,
          })
        })
      }
      })
      .catch(error => console.log(error));

      getStatusJadwalSidang()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.statusJadwalOption.options.push({
            label: element.nama,
            value: element.uuid,
          })
        })
      }
      })
      .catch(error => console.log(error));
  },
  methods: {
    cari()
    {
      this.count += 1
      this.$emit('update:dataFilter', this.filter)
      this.$emit('update:triggerFilter', this.count)
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
